/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import Select from "react-select";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData, putData, uploadMultipleFile } from "utils/Gateway";

import RemoteOptions from "data/Prod/RemoteOptions.json";
import JobTypeOptions from "data/Prod/JobTypeOptions.json";
import JobAssociateOptions from "data/Prod/JobAssociateOptions.json";
import CurrencyOptions from "data/Prod/Currency.json";
import PaymentDurationOptions from "data/Prod/PaymentDuration.json";
import ChallengeTypeOptions from "data/Challenge/ChallengeType.json";

import SaveJobSuccessModal from "../Modal/SaveJobSuccessModal";
import {
  challengeHeaderLinks,
  challnegeBreadCrumbText,
} from "helper/ChallengeHelper/ChallengeHelper";
import { ecosystemSlug, reactSelectStyle } from "Config/Config";
import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";

// ✅ Reusable required label component
const RequiredLabel = ({ htmlFor, className, children }) => (
  <label htmlFor={htmlFor} className={className}>
    {children}
    <span className="text-danger ms-1">*</span>
  </label>
);

const JobInformationBody = () => {
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const docFileInputRef = useRef(null);

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t } = useTranslation();

  const challengeTypeParams = queryParams.get("type") || "talenthunt";
  const commonHeaderObject = challengeHeaderLinks(params.id, t);

  const [companyInput, setCompanyInput] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [allSkills, setAllSkills] = useState([]);
  const [challengetype, setChallengetype] = useState(challengeTypeParams);
  const [title, setTitle] = useState("");
  const [code, setcode] = useState("");
  const [summary, setsummary] = useState("");
  const [details, setdetails] = useState("");
  const [aboutCompany, setaboutCompany] = useState("");
  const [aboutPosition, setaboutPosition] = useState("");
  const [requiredSkillValue, setrequiredSkillValue] = useState(null);
  const [requiredSkills, setrequiredSkills] = useState([]);
  const [optionalSkillValue, setoptionalSkillValue] = useState(null);
  const [optionalSkills, setoptionalSkills] = useState([]);
  const [remoteJobValue, setremoteJobValue] = useState(null);
  const [jobTypeValue, setjobTypeValue] = useState(null);
  const [experienceAsValue, setexperienceAsValue] = useState(null);
  const [experienceYear, setexperienceYear] = useState("");
  const [experienceMonth, setexperienceMonth] = useState("");
  const [currencyValue, setcurrencyValue] = useState(null);
  const [paymentDurationValue, setpaymentDurationValue] = useState(null);
  const [minSalary, setminSalary] = useState("");
  const [maxSalary, setmaxSalary] = useState("");
  const [companyValue, setcompanyValue] = useState(null);
  const [companyName, setcompanyName] = useState("");
  const [companyAdress, setcompanyAdress] = useState("");
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [uploadedDocFileIds, setUploadedDocFileIds] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [savedJobId, setsavedJobId] = useState(null);
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  /* ---- bread crumb text ---- */
  const breadcrumbText = challnegeBreadCrumbText(t("Details"), title, t);

  // Custom styles for select fields
  const customSelectStyles = (hasError) => ({
    control: (base) => ({
      ...base,
      borderColor: hasError ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: hasError ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({ ...base, color: "#6c757d" }),
    input: (base) => ({ ...base }),
    singleValue: (base) => ({ ...base }),
  });

  // Validation
  const validationHandler = () => {
    const newErrors = {};

    if (!title.trim()) newErrors.title = t("Title is required");
    if (!code.trim()) newErrors.code = t("Code is required");
    if (!summary.trim()) newErrors.summary = t("Summary is required");
    if (!details.trim()) newErrors.details = t("Details is required");

    if (companyValue === null && !companyName.trim())
      newErrors.company = t("Please select or type company");

    if (requiredSkills.length === 0)
      newErrors.requiredSkills = t("Skill is required");

    if (currencyValue === null) newErrors.currency = t("Currency is required");

    if (!minSalary.trim())
      newErrors.minSalary = t("Minimum salary is required");

    if (!maxSalary.trim())
      newErrors.maxSalary = t("Maximum salary is required");

    if (
      minSalary !== "" &&
      maxSalary !== "" &&
      parseInt(minSalary) > parseInt(maxSalary)
    ) {
      newErrors.salaryDiff = t(
        "Maximum salary should be greater than minimum salary",
      );
    }

    if (paymentDurationValue === null)
      newErrors.paymentDuration = t("Please select payment duration");

    if (!zipcode.trim()) newErrors.zipcode = t("Please enter zipcode");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Get all skills
  const getAllSkills = async () => {
    try {
      const parentSlug = "skills";
      const response = await getAllCategories(ecosystemSlug, parentSlug);
      setAllSkills(response);
    } catch (error) {
      setShowAlert(true);
      setMessageType("error");
      setAlertMessage(error.message);
    }
  };

  // Get company list
  const getAllCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?filtername=${companyInput}`;

      const response = await getData(requestUrl);
      if (response.status) setCompanyList(response.data);
    } catch (error) {
      setShowAlert(true);
      setMessageType("error");
      setAlertMessage(error.message);
    }
  };

  const requiredSkillSelectionHandler = (val) => {
    setrequiredSkillValue(val);
    setrequiredSkills(val.map((item) => item.value));
    if (errors.requiredSkills)
      setErrors((prev) => ({ ...prev, requiredSkills: "" }));
  };

  const optionalSkillSelectionHandler = (val) => {
    setoptionalSkillValue(val);
    setoptionalSkills(val.map((item) => item.value));
  };

  const remoteJobSelectionHandler = (val) => setremoteJobValue(val);
  const jobTypeSelectionHandler = (val) => setjobTypeValue(val);
  const experienceAsSelectionHandler = (val) => setexperienceAsValue(val);

  const currencySelectionHandler = (val) => {
    setcurrencyValue(val);
    if (errors.currency) setErrors((prev) => ({ ...prev, currency: "" }));
  };

  const paymentDurationSelectionHandler = (val) => {
    setpaymentDurationValue(val);
    if (errors.paymentDuration)
      setErrors((prev) => ({ ...prev, paymentDuration: "" }));
  };

  const companySelectionHandler = (val) => {
    if (val) {
      setcompanyValue(val);
      setcompanyAdress(val.location);
      setaboutCompany(val.about);
      if (errors.company) setErrors((prev) => ({ ...prev, company: "" }));
    } else {
      setcompanyValue(null);
      setCompanyInput("");
      setCompanyList([]);
    }
  };

  const getLocationFromZip = async (e) => {
    e.preventDefault();
    if (zipcode !== "") {
      try {
        const mapUrl = `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${zipcode}&region=es&key=AIzaSyDt4dbtdHCHLj8grTzTVxpztvqUGDkvkaI`;
        const response = await getData(mapUrl);
        if (response.status === "OK") {
          const results = response.results;
          if (results.length > 0) {
            results[0]?.address_components.map((item) => {
              if (item.types[0] === "country") setcountry(item?.long_name);
              if (item.types[0] === "locality") setcityName(item?.long_name);
              if (item.types[0] === "administrative_area_level_1")
                setstateName(item?.long_name);
            });
          }
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    }
  };

  const docFileUploadHandler = async (docFiles) => {
    if (docFiles.length > 0) {
      try {
        setDocFileUploading(true);
        let requestUrl =
          url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD;
        const response = await uploadMultipleFile(requestUrl, docFiles);
        if (response.status) {
          const uploadedFileValues = response.data.map(
            ({ name, path, _id }) => ({ name, path, _id }),
          );
          setUploadedDocFiles((prev) =>
            prev.length === 0
              ? uploadedFileValues
              : prev.concat(uploadedFileValues),
          );
          const fileIds = response.data.map(({ _id }) => ({ _id }));
          setUploadedDocFileIds((prev) =>
            prev.length === 0 ? fileIds : prev.concat(fileIds),
          );
        }
        setDocFileUploading(false);
        resetDocInput();
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const closeDocFileHandler = (index) => {
    const closedFile = [...uploadedDocFiles];
    const removedFileId = [...uploadedDocFileIds];
    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);
    setUploadedDocFiles(closedFile);
    setUploadedDocFileIds(removedFileId);
    resetDocInput();
  };

  const resetDocInput = () => {
    const file = document.getElementById("uploadedChallengeDoc");
    if (file) file.value = null;
  };

  const getJobDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CHALLENGE_DETAILS +
        `/${params.id}`;
      const response = await getData(requestUrl);
      if (response.status && response.data) {
        const data = response.data;
        setTitle(data.name);
        setcode(data.jobcode);
        setChallengetype(data.challengetype);
        setsummary(data.summary);
        setdetails(data.description);
        setaboutPosition(data.aboutposition);
        requiredSkillSelectionHandler(data.requiredskillsdata);
        optionalSkillSelectionHandler(data.optionalskillsdata);

        for (let remoteData of RemoteOptions) {
          if (data.remotejob == remoteData.value)
            remoteJobSelectionHandler(remoteData);
        }
        for (let jobType of JobTypeOptions) {
          if (data.jobtype == jobType.value) jobTypeSelectionHandler(jobType);
        }
        for (let experienceData of JobAssociateOptions) {
          if (data.experienceposition == experienceData.value)
            experienceAsSelectionHandler(experienceData);
        }

        setexperienceYear(
          data.experienceyear ? data.experienceyear.toString() : "",
        );
        setexperienceMonth(
          data.experienceMonth ? data.experienceMonth.toString() : "",
        );

        for (let currency of CurrencyOptions) {
          if (data.currency == currency.value)
            currencySelectionHandler(currency);
        }

        setminSalary(data.minsalary ? data.minsalary.toString() : "");
        setmaxSalary(data.maxsalary ? data.maxsalary.toString() : "");

        for (let payment of PaymentDurationOptions) {
          if (data.paymentduration == payment.value)
            paymentDurationSelectionHandler(payment);
        }

        setcompanyValue(data.companydata);
        setaboutCompany(data.aboutcompany);
        setcompanyName(data.companystring);
        setcompanyAdress(data.location);
        setzipcode(data.zipcode ? data.zipcode.toString() : "");
        setcityName(data.city);
        setstateName(data.state);
        setcountry(data.country);
        setUploadedDocFiles(response?.data?.uploadedfiles);
        setUploadedDocFileIds(response?.data?.uploadedfileids);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const saveJobHandler = async () => {
    if (!validationHandler()) {
      setErrorMessage(t("Please fix the errors in the form."));
      window.scrollTo({ top: 0, behavior: "smooth" }); // ✅ smooth scroll
      return;
    }

    try {
      setIsSaving(true);
      let projectData = {
        challengetype,
        name: title,
        jobtype: jobTypeValue ? jobTypeValue.value : "",
        jobcode: code,
        summary,
        description: details,
        companyid: companyValue ? companyValue.value : null,
        companystring: companyValue ? "" : companyName,
        aboutcompany: aboutCompany,
        aboutposition: aboutPosition,
        requiredskills: requiredSkills,
        optionalskills: optionalSkills,
        currency: currencyValue ? currencyValue.value : "",
        minsalary: minSalary,
        maxsalary: maxSalary,
        paymentduration: paymentDurationValue ? paymentDurationValue.value : "",
        experienceposition: experienceAsValue ? experienceAsValue.value : "",
        experienceyear: experienceYear,
        experiencemonth: experienceMonth,
        location: companyAdress,
        city: cityName,
        state: stateName,
        country,
        zipcode,
        remotejob: remoteJobValue ? remoteJobValue.value : "",
        publish: "Yes",
        uploads: uploadedDocFileIds,
      };

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (params.id) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_CHALLENGE +
          `/${params.id}`;
        response = await putData(requestUrl, projectData);
      } else {
        requestUrl = requestUrl + url.API_ADD_CHALLENGE;
        response = await postData(requestUrl, projectData);
      }

      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        setsavedJobId(response.data._id);
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveChallengeModal"),
        );
        bootstrapModal.show();
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  const resetHandler = () => {
    setCompanyInput("");
    setCompanyList([]);
    setTitle("");
    setcode("");
    setdetails("");
    setaboutCompany("");
    setaboutPosition("");
    setrequiredSkillValue(null);
    setrequiredSkills([]);
    setoptionalSkillValue(null);
    setoptionalSkills([]);
    for (let remoteData of RemoteOptions) {
      if (remoteData.value == "no") remoteJobSelectionHandler(remoteData);
    }
    for (let jobData of JobTypeOptions) {
      if (jobData.value == "fulltime") jobTypeSelectionHandler(jobData);
    }
    for (let experienceData of JobAssociateOptions) {
      if (experienceData.value == "associate")
        experienceAsSelectionHandler(experienceData);
    }
    setexperienceYear("");
    setexperienceMonth("");
    for (let currencyData of CurrencyOptions) {
      if (currencyData.value == "euro") currencySelectionHandler(currencyData);
    }
    for (let paymentData of PaymentDurationOptions) {
      if (paymentData.value == "Monthly")
        paymentDurationSelectionHandler(paymentData);
    }
    setminSalary("");
    setmaxSalary("");
    setcompanyValue(null);
    setcompanyName("");
    setcompanyAdress("");
    setstateName("");
    setcountry("");
    setzipcode("");
    setUploadedDocFiles([]);
    setUploadedDocFileIds([]);
    setErrors({});
    setErrorMessage("");
  };

  const afterSaveModalClose = (pageName) => {
    if (pageName == "details") {
      history.push(`/admin/challenges/jobinformation/${savedJobId}`);
    } else {
      resetHandler();
      history.push("/admin/challenges/list");
    }
  };

  useEffect(() => {
    if (companyInput.length > 0) getAllCompanyList();
  }, [companyInput]);

  useEffect(() => {
    if (params.id) getJobDetails();
  }, [params.id]);

  useEffect(() => {
    getAllSkills();
    for (let remoteData of RemoteOptions) {
      if (remoteData.value == "no") remoteJobSelectionHandler(remoteData);
    }
    for (let jobData of JobTypeOptions) {
      if (jobData.value == "fulltime") jobTypeSelectionHandler(jobData);
    }
    for (let experienceData of JobAssociateOptions) {
      if (experienceData.value == "associate")
        experienceAsSelectionHandler(experienceData);
    }
    for (let currencyData of CurrencyOptions) {
      if (currencyData.value == "euro") currencySelectionHandler(currencyData);
    }
    for (let paymentData of PaymentDurationOptions) {
      if (paymentData.value == "Monthly")
        paymentDurationSelectionHandler(paymentData);
    }
  }, []);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CHALLENGE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          {/* ---- common header ---- */}
          {params.id && (
            <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Job Information")}
            />
          )}

          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {/* ---- bread crumb ------- */}
            <BreadCrumb breadCrumbText={breadcrumbText} bottom={true} />

            {/* -------- form section ----------- */}
            <div className="row">
              <div className="col-lg-12 mb-4 mb-lg-0">
                <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
                  <form onSubmit={(e) => e.preventDefault()}>
                    {/* ========== Title ========== */}
                    <div className="form-group mb-4">
                      <RequiredLabel
                        htmlFor="title"
                        className="d-block fs-sm fw-semibold mb-2"
                      >
                        {t("Title")}
                      </RequiredLabel>
                      <input
                        type="text"
                        id="title"
                        className={`form-control fs-sm shadow-none ${
                          errors.title ? "is-invalid" : "border border-gray-300"
                        }`}
                        placeholder={t("e.g., Senior Frontend Developer")}
                        value={title}
                        onChange={(e) => {
                          setTitle(e.target.value);
                          if (errors.title)
                            setErrors((prev) => ({ ...prev, title: "" }));
                        }}
                      />
                      {errors.title && (
                        <div className="invalid-feedback d-block">
                          {errors.title}
                        </div>
                      )}
                    </div>

                    {/* ========== Job Code + Challenge Type ========== */}
                    <div className="form-group mb-4">
                      <div className="row">
                        <div className="col-lg-6 mb-3 mb-lg-0">
                          <RequiredLabel
                            htmlFor="jobCode"
                            className="d-block fs-sm fw-semibold mb-2"
                          >
                            {t("Job Code")}
                          </RequiredLabel>
                          <input
                            type="text"
                            id="jobCode"
                            className={`form-control fs-sm shadow-none ${
                              errors.code
                                ? "is-invalid"
                                : "border border-gray-300"
                            }`}
                            placeholder={t("e.g., DEV-001")}
                            value={code}
                            onChange={(e) => {
                              setcode(e.target.value);
                              if (errors.code)
                                setErrors((prev) => ({ ...prev, code: "" }));
                            }}
                          />
                          {errors.code && (
                            <div className="invalid-feedback d-block">
                              {errors.code}
                            </div>
                          )}
                        </div>
                        <div className="col-lg-6">
                          <label
                            htmlFor="challengeType"
                            className="d-block fs-sm fw-semibold mb-2"
                          >
                            {t("Challenge Type")}
                          </label>
                          <Select
                            styles={reactSelectStyle("3px", "6px", true, false)}
                            id="challengeType"
                            placeholder={t(
                              "e.g., Coding Challenge, Case Study",
                            )}
                            options={ChallengeTypeOptions}
                            value={ChallengeTypeOptions.find(
                              (option) => option.value === challengetype,
                            )}
                            onChange={(val) => setChallengetype(val.value)}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ========== Accordion ========== */}
                    <div
                      className="accordion mb-4"
                      id="accordionPanelsStayOpenExample"
                    >
                      {/* ---- Job Description ---- */}
                      <div className="accordion-item bg-transparent border-0">
                        <h3 className="accordion-header">
                          <button
                            className="accordion-button bg-transparent p-0 shadow-none"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-jobdesc"
                            aria-expanded="true"
                            aria-controls="collapse-jobdesc"
                          >
                            {t("Job Description")}
                          </button>
                        </h3>
                        <div
                          id="collapse-jobdesc"
                          className="accordion-collapse collapse show"
                        >
                          <div className="accordion-body p-0 pt-4">
                            {/* Job Summary */}
                            <div className="form-group mb-4">
                              <RequiredLabel
                                htmlFor="jobSummarys"
                                className="d-block fs-sm fw-semibold mb-2"
                              >
                                {t("Job Summary")}
                              </RequiredLabel>
                              <textarea
                                name="jobSummarys"
                                id="jobSummarys"
                                cols="30"
                                rows="5"
                                className={`form-control fs-sm shadow-none ${
                                  errors.summary
                                    ? "is-invalid"
                                    : "border border-gray-300"
                                }`}
                                placeholder={t(
                                  "Write a brief, engaging overview of the role and its key responsibilities.",
                                )}
                                value={summary}
                                onChange={(e) => {
                                  setsummary(e.target.value);
                                  if (errors.summary)
                                    setErrors((prev) => ({
                                      ...prev,
                                      summary: "",
                                    }));
                                }}
                              />
                              {errors.summary && (
                                <div className="invalid-feedback d-block">
                                  {errors.summary}
                                </div>
                              )}
                            </div>

                            {/* Job Details — JoditEditorField */}
                            <JoditEditorField
                              label={t("Job Details")}
                              labelClassName="d-block fs-sm fw-semibold mb-2"
                              editorHeight={300}
                              value={details}
                              required={true}
                              onChange={(newContent) => {
                                setdetails(newContent);
                                if (errors.details)
                                  setErrors((prev) => ({
                                    ...prev,
                                    details: "",
                                  }));
                              }}
                            />
                            {errors.details && (
                              <div className="invalid-feedback d-block mt-1 mb-3">
                                {errors.details}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* ---- Company ---- */}
                      {/* ✅ Fixed: unique id — was "panelsStayOpen-collapseFive" (duplicate) */}
                      <div className="accordion-item bg-transparent border-0">
                        <h3 className="accordion-header">
                          <button
                            className="accordion-button bg-transparent p-0 shadow-none"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-company"
                            aria-expanded="true"
                            aria-controls="collapse-company"
                          >
                            {t("Company")}
                          </button>
                        </h3>
                        <div
                          id="collapse-company"
                          className="accordion-collapse collapse show"
                        >
                          <div className="accordion-body p-0 pt-4">
                            <div className="form-group mb-4">
                              <div className="row">
                                <div className="col-lg-4 mb-3 mb-lg-0">
                                  <RequiredLabel
                                    htmlFor="industry"
                                    className="d-block fs-sm fw-semibold mb-2"
                                  >
                                    {t("Select Company")}
                                  </RequiredLabel>
                                  <Select
                                    isClearable
                                    styles={customSelectStyles(errors.company)}
                                    placeholder={t("Search for a company...")}
                                    options={companyList}
                                    value={companyValue}
                                    onChange={companySelectionHandler}
                                    onInputChange={(val) =>
                                      setCompanyInput(val)
                                    }
                                  />
                                </div>
                                <div className="col-lg-4 mb-3 mb-lg-0">
                                  <label
                                    htmlFor="companyName"
                                    className="d-block fs-sm fw-semibold mb-2"
                                  >
                                    {t(
                                      "Enter Company Name (If not in the list)",
                                    )}
                                  </label>
                                  <input
                                    type="text"
                                    id="companyName"
                                    className={`form-control fs-sm shadow-none ${
                                      errors.company && companyValue === null
                                        ? "is-invalid"
                                        : "border border-gray-300"
                                    }`}
                                    placeholder={t("e.g., Acme Corporation")}
                                    value={companyName}
                                    onChange={(e) => {
                                      setcompanyName(e.target.value);
                                      if (errors.company)
                                        setErrors((prev) => ({
                                          ...prev,
                                          company: "",
                                        }));
                                    }}
                                  />
                                </div>
                                <div className="col-lg-4">
                                  <label
                                    htmlFor="companyAddress"
                                    className="d-block fs-sm fw-semibold mb-2"
                                  >
                                    {t("Address")}
                                  </label>
                                  <input
                                    type="text"
                                    id="companyAddress"
                                    className="form-control fs-sm shadow-none border border-gray-300"
                                    placeholder={t(
                                      "e.g., 123 Main St, Anytown, USA",
                                    )}
                                    value={companyAdress}
                                    onChange={(e) =>
                                      setcompanyAdress(e.target.value)
                                    }
                                  />
                                </div>
                                {errors.company && (
                                  <div className="invalid-feedback d-block mt-2">
                                    {errors.company}
                                  </div>
                                )}
                              </div>
                            </div>

                            <JoditEditorField
                              label={t("About Company")}
                              labelClassName="d-block fs-sm fw-semibold mb-2"
                              value={aboutCompany}
                              onChange={(newContent) =>
                                setaboutCompany(newContent)
                              }
                            />

                            <JoditEditorField
                              label={t("About Position")}
                              labelClassName="d-block fs-sm fw-semibold mb-2"
                              value={aboutPosition}
                              onChange={(newContent) =>
                                setaboutPosition(newContent)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {/* ---- Skills ---- */}
                      <div className="accordion-item bg-transparent border-0">
                        <h3 className="accordion-header">
                          <button
                            className="accordion-button bg-transparent p-0 shadow-none"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-skills"
                            aria-expanded="true"
                            aria-controls="collapse-skills"
                          >
                            {t("Add Skills")}
                          </button>
                        </h3>
                        <div
                          id="collapse-skills"
                          className="accordion-collapse collapse show"
                        >
                          <div className="accordion-body p-0 pt-4">
                            <div className="form-group mb-4">
                              <RequiredLabel
                                htmlFor="required"
                                className="d-block fs-sm fw-semibold mb-2"
                              >
                                {t("Required Skills")}
                              </RequiredLabel>
                              <Select
                                isMulti
                                styles={customSelectStyles(
                                  errors.requiredSkills,
                                )}
                                placeholder={t("e.g., JavaScript, React, CSS")}
                                options={allSkills}
                                value={requiredSkillValue}
                                onChange={requiredSkillSelectionHandler}
                              />
                              {errors.requiredSkills && (
                                <div className="invalid-feedback d-block mt-2">
                                  {errors.requiredSkills}
                                </div>
                              )}
                            </div>
                            <div className="form-group">
                              <label
                                htmlFor="option"
                                className="d-block fs-sm fw-semibold mb-2"
                              >
                                {t("Optional Skills")}
                              </label>
                              <Select
                                isMulti
                                styles={reactSelectStyle(
                                  "3px",
                                  "6px",
                                  true,
                                  false,
                                )}
                                placeholder={t(
                                  "e.g., TypeScript, GraphQL, Docker",
                                )}
                                options={allSkills}
                                value={optionalSkillValue}
                                onChange={optionalSkillSelectionHandler}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ---- Experience ---- */}
                      <div className="accordion-item bg-transparent border-0">
                        <h3 className="accordion-header">
                          <button
                            className="accordion-button bg-transparent p-0 shadow-none"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-experience"
                            aria-expanded="true"
                            aria-controls="collapse-experience"
                          >
                            {t("Experience")}
                          </button>
                        </h3>
                        <div
                          id="collapse-experience"
                          className="accordion-collapse collapse show"
                        >
                          <div className="accordion-body p-0 pt-4">
                            <div className="form-group mb-4">
                              <div className="row">
                                <div className="col-lg-6 mb-4 mb-lg-0">
                                  <label className="d-block fs-sm fw-semibold mb-2">
                                    {t("Remote Job")}
                                  </label>
                                  <Select
                                    styles={reactSelectStyle(
                                      "3px",
                                      "6px",
                                      true,
                                      false,
                                    )}
                                    placeholder={t(
                                      "e.g., Fully Remote, Hybrid, On-site",
                                    )}
                                    options={RemoteOptions}
                                    value={remoteJobValue}
                                    onChange={remoteJobSelectionHandler}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="d-block fs-sm fw-semibold mb-2">
                                    {t("Type")}
                                  </label>
                                  <Select
                                    styles={reactSelectStyle(
                                      "3px",
                                      "6px",
                                      true,
                                      false,
                                    )}
                                    placeholder={t(
                                      "e.g., Full-time, Part-time, Contract",
                                    )}
                                    options={JobTypeOptions}
                                    value={jobTypeValue}
                                    onChange={jobTypeSelectionHandler}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="form-group mb-4">
                              <div className="row">
                                <div className="col-lg-6 mb-4 mb-lg-0">
                                  <label className="d-block fs-sm fw-semibold mb-2">
                                    {t("Experience as")}
                                  </label>
                                  <Select
                                    styles={reactSelectStyle(
                                      "3px",
                                      "6px",
                                      true,
                                      false,
                                    )}
                                    placeholder={t(
                                      "e.g., Individual Contributor, Team Lead",
                                    )}
                                    options={JobAssociateOptions}
                                    value={experienceAsValue}
                                    onChange={experienceAsSelectionHandler}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="d-block fs-sm fw-semibold mb-2">
                                    {t("Experience Time")}
                                  </label>
                                  <div className="d-flex flex-column flex-lg-row gap-3">
                                    <input
                                      type="number"
                                      className="form-control fs-sm shadow-none border border-gray-300"
                                      placeholder={t("Years (e.g., 5)")}
                                      value={experienceYear}
                                      onChange={(e) =>
                                        setexperienceYear(e.target.value)
                                      }
                                    />
                                    <input
                                      type="number"
                                      className="form-control fs-sm shadow-none border border-gray-300"
                                      placeholder={t("Months (e.g., 6)")}
                                      value={experienceMonth}
                                      onChange={(e) =>
                                        setexperienceMonth(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Pay Rate */}
                            <div className="form-group">
                              <label className="d-block fs-sm fw-semibold mb-2">
                                {t("Pay Rate (Salary)")}
                              </label>
                              <div className="d-flex flex-column flex-lg-row gap-4 rounded-10">
                                <div className="w-100">
                                  <RequiredLabel className="d-block fs-sm fw-semibold mb-2">
                                    {t("Currency")}
                                  </RequiredLabel>
                                  <Select
                                    styles={customSelectStyles(errors.currency)}
                                    className="w-100"
                                    placeholder={t("e.g., USD, EUR, INR")}
                                    options={CurrencyOptions}
                                    value={currencyValue}
                                    onChange={currencySelectionHandler}
                                  />
                                  {errors.currency && (
                                    <div className="invalid-feedback d-block">
                                      {errors.currency}
                                    </div>
                                  )}
                                </div>
                                <div className="w-100">
                                  <RequiredLabel className="d-block fs-sm fw-semibold mb-2">
                                    {t("Payment Duration")}
                                  </RequiredLabel>
                                  <Select
                                    styles={customSelectStyles(
                                      errors.paymentDuration,
                                    )}
                                    className="w-100"
                                    placeholder={t("e.g., Per Year, Per Month")}
                                    options={PaymentDurationOptions}
                                    value={paymentDurationValue}
                                    onChange={paymentDurationSelectionHandler}
                                  />
                                  {errors.paymentDuration && (
                                    <div className="invalid-feedback d-block">
                                      {errors.paymentDuration}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="mt-3 d-flex flex-column flex-lg-row gap-4 rounded-10">
                                <div className="w-100">
                                  <RequiredLabel className="d-block fs-sm fw-semibold mb-2">
                                    {t("Minimum Salary")}
                                  </RequiredLabel>
                                  <input
                                    type="number"
                                    min={0}
                                    className={`form-control fs-sm shadow-none ${
                                      errors.minSalary
                                        ? "is-invalid"
                                        : "border border-gray-300"
                                    }`}
                                    placeholder={t(
                                      "Minimum Salary (e.g., 80000)",
                                    )}
                                    value={minSalary}
                                    onChange={(e) => {
                                      setminSalary(e.target.value.toString());
                                      if (errors.minSalary)
                                        setErrors((prev) => ({
                                          ...prev,
                                          minSalary: "",
                                        }));
                                      if (errors.salaryDiff)
                                        setErrors((prev) => ({
                                          ...prev,
                                          salaryDiff: "",
                                        }));
                                    }}
                                  />
                                  {errors.minSalary && (
                                    <div className="invalid-feedback d-block">
                                      {errors.minSalary}
                                    </div>
                                  )}
                                </div>
                                <div className="w-100">
                                  <RequiredLabel className="d-block fs-sm fw-semibold mb-2">
                                    {t("Maximum Salary")}
                                  </RequiredLabel>
                                  <input
                                    type="number"
                                    min={0}
                                    className={`form-control fs-sm shadow-none ${
                                      errors.maxSalary
                                        ? "is-invalid"
                                        : "border border-gray-300"
                                    }`}
                                    placeholder={t(
                                      "Maximum Salary (e.g., 120000)",
                                    )}
                                    value={maxSalary}
                                    onChange={(e) => {
                                      setmaxSalary(e.target.value.toString());
                                      if (errors.maxSalary)
                                        setErrors((prev) => ({
                                          ...prev,
                                          maxSalary: "",
                                        }));
                                      if (errors.salaryDiff)
                                        setErrors((prev) => ({
                                          ...prev,
                                          salaryDiff: "",
                                        }));
                                    }}
                                  />
                                  {errors.maxSalary && (
                                    <div className="invalid-feedback d-block">
                                      {errors.maxSalary}
                                    </div>
                                  )}
                                  {errors.salaryDiff && (
                                    <div className="invalid-feedback d-block">
                                      {errors.salaryDiff}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ---- Location ---- */}
                      {/* ✅ Fixed: unique id — was "panelsStayOpen-collapseFive" (duplicate) */}
                      <div className="accordion-item bg-transparent border-0">
                        <h3 className="accordion-header">
                          <button
                            className="accordion-button bg-transparent p-0 shadow-none"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse-location"
                            aria-expanded="true"
                            aria-controls="collapse-location"
                          >
                            {t("Location")}
                          </button>
                        </h3>
                        <div
                          id="collapse-location"
                          className="accordion-collapse collapse show"
                        >
                          <div className="accordion-body p-0 pt-4">
                            <div className="form-group mb-3">
                              <div className="row">
                                {/* Zipcode */}
                                <div className="col-lg-4 mb-3 mb-lg-0">
                                  <RequiredLabel className="d-block fs-sm fw-semibold mb-2">
                                    {t("Zip Code")}
                                  </RequiredLabel>
                                  <div className="d-flex gap-2">
                                    <input
                                      type="text"
                                      className={`form-control shadow-none ${
                                        errors.zipcode
                                          ? "is-invalid"
                                          : "border border-gray-300"
                                      }`}
                                      placeholder={t("Enter Zip Code")}
                                      value={zipcode}
                                      onChange={(e) => {
                                        setzipcode(e.target.value);
                                        if (errors.zipcode)
                                          setErrors((prev) => ({
                                            ...prev,
                                            zipcode: "",
                                          }));
                                      }}
                                    />
                                    <button
                                      className="btn btn-primary text-nowrap"
                                      onClick={getLocationFromZip}
                                    >
                                      {t("Fetch")}
                                    </button>
                                  </div>
                                  {errors.zipcode && (
                                    <div className="invalid-feedback d-block mt-1">
                                      {errors.zipcode}
                                    </div>
                                  )}
                                </div>

                                {/* City, State, Country */}
                                <div className="col-lg-8">
                                  <label className="d-block fs-sm fw-semibold mb-2">
                                    {t("City / State / Country")}
                                  </label>
                                  <div className="row">
                                    <div className="col-lg-4 mb-3 mb-lg-0">
                                      <input
                                        type="text"
                                        className="form-control shadow-none border border-gray-300"
                                        placeholder={t("e.g., San Francisco")}
                                        value={cityName}
                                        onChange={(e) =>
                                          setcityName(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="col-lg-4 mb-3 mb-lg-0">
                                      <input
                                        type="text"
                                        className="form-control shadow-none border border-gray-300"
                                        placeholder={t("e.g., California")}
                                        value={stateName}
                                        onChange={(e) =>
                                          setstateName(e.target.value)
                                        }
                                      />
                                    </div>
                                    <div className="col-lg-4">
                                      <input
                                        type="text"
                                        className="form-control shadow-none border border-gray-300"
                                        placeholder={t("e.g., USA")}
                                        value={country}
                                        onChange={(e) =>
                                          setcountry(e.target.value)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ========== End Accordion ========== */}

                    {/* Upload Documents */}
                    <div className="form-group mb-3 mb-sm-4">
                      <label
                        htmlFor="documents"
                        className="d-block fs-md fw-semibold mb-2"
                      >
                        {t("Upload Documents")}
                      </label>
                      <FileUploadField
                        label={t("Upload Documents")}
                        accept="doc mp4 pdf"
                        onUpload={docFileUploadHandler}
                        files={uploadedDocFiles}
                        onRemove={closeDocFileHandler}
                        loading={docFileUploading}
                        multiple
                        fileType="document"
                      />
                    </div>

                    {/* Error message */}
                    {errorMessage && (
                      <div className="alert alert-danger" role="alert">
                        {errorMessage}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>

          <SaveJobSuccessModal afterSaveModalClose={afterSaveModalClose} />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>

        {/* ✅ Fixed Footer */}
        <div className="fixed-bottom bg-white border-top shadow-lg py-3">
          <div className="container-fluid px-lg-5">
            <div className="d-flex justify-content-between align-items-center">
              <Link
                to="/admin/challenges/list"
                className="btn btn-outline-primary px-4 d-flex align-items-center"
                onClick={resetHandler}
              >
                <span className="material-symbols-outlined align-middle me-1">
                  cancel
                </span>
                {t("Cancel")}
              </Link>

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  title={t("Scroll to Top")}
                >
                  <span className="material-symbols-outlined">
                    keyboard_arrow_up
                  </span>
                </button>

                <button
                  onClick={saveJobHandler}
                  type="button"
                  className="btn btn-primary px-4"
                  disabled={isSaving}
                  style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                >
                  <span className="material-symbols-outlined align-middle me-1">
                    save
                  </span>
                  {t("Post Now")}
                  {isSaving && (
                    <div
                      className="mx-2 spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default JobInformationBody;
